/**
 * DTOs de dominios propios de una organización (`/orgs/:orgId/domains`). Ver docs/FASE-0.md §5
 * "Organizaciones" y §3 `organization_domains`.
 */
import { z } from "zod";
import { PATTERNS } from "../constants.js";
/** Nombre de dominio válido: al menos una etiqueta, sin guiones en los extremos. */
const DOMAIN_PATTERN = /^(?!-)[a-z0-9-]{1,63}(?<!-)(\.(?!-)[a-z0-9-]{1,63}(?<!-))+$/i;
export const CreateOrganizationDomainInputSchema = z.object({
    domain: z.string().min(3).max(253).regex(DOMAIN_PATTERN),
    moduleCode: z.string().regex(PATTERNS.MODULE_CODE),
});
/** Subdominio fijo donde se publica el TXT de verificación (docs/FASE-4.md §5.3). */
export const DOMAIN_VERIFICATION_TXT_PREFIX = "_continnua-verify";
export const OrganizationDomainSchema = z.object({
    id: z.uuid(),
    orgId: z.uuid(),
    domain: z.string(),
    moduleCode: z.string().regex(PATTERNS.MODULE_CODE),
    /** No nulo cuando la verificación DNS del TXT tuvo éxito, o un operador la estampó a mano
     * (`?force=true`, auditado por separado como `organization_domain.verified_manually`). */
    verifiedAt: z.iso.datetime().nullable(),
    verificationToken: z.string(),
    /** Nombre del registro TXT a publicar (`_continnua-verify.<domain>`). Derivado de `domain`, no
     * es una columna: se calcula igual en cada lectura para que la consola sepa qué mostrarle al
     * operador sin duplicar la regla en dos sitios. */
    verificationRecordName: z.string(),
    /** Valor que ese TXT debe traer. Hoy coincide con `verificationToken`; se expone con su propio
     * nombre para que la consola no tenga que saber que "el valor a pegar" y "el token interno" son
     * lo mismo. */
    verificationRecordValue: z.string(),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
});
//# sourceMappingURL=domains.js.map